import React from 'react'
import { Grid, Header } from 'semantic-ui-react'
import FileUploadButton from '../../fileUploadButton'

const BlogImages = ({ obj, onChange, defaultType }) => {
  return (
    <div>
      <Grid columns={4}>
        <Grid.Row columns={1}>
          <Grid.Column>
            <Header as='h3'>Header</Header>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          { obj.type && defaultType === obj.type &&
            <Grid.Column>
              <FileUploadButton id='header_desktop' label='Header (desktop)' image={obj.header_desktop} onChange={onChange} />
            </Grid.Column>
          }
          { obj.type && defaultType === obj.type &&
            <Grid.Column>
              <FileUploadButton id='header_mobile' label='Header (mobile)' image={obj.header_mobile} onChange={onChange} />
            </Grid.Column>
          }
          <Grid.Column>
            <FileUploadButton id='img_featured_desktop' label='Vignette (desktop)' image={obj.img_featured_desktop} onChange={onChange} />
          </Grid.Column>
          <Grid.Column>
            <FileUploadButton id='img_featured_mobile' label='Vignette (mobile)' image={obj.img_featured_mobile} onChange={onChange} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  )
}

export default BlogImages



// WEBPACK FOOTER //
// ./src/components/form/article/images.js